export enum ButtonType {
  Simple = 'Simple',
  OnlyImage = 'OnlyImage',
  WithIcon = 'WithIcon',
  Bordered = 'Bordered',
}
